import type { ImgHTMLAttributes } from "react";

interface PictureProps extends ImgHTMLAttributes<HTMLImageElement> {
  /** Preferred (modern) WebP source set, e.g. "a.webp 400w, b.webp 800w" or a single URL. */
  webpSrcSet: string;
  /** Fallback (JPEG/PNG) responsive source set for older browsers. Optional for single-size images. */
  fallbackSrcSet?: string;
  /** Fallback (JPEG/PNG) src used by browsers without WebP support. */
  fallbackSrc: string;
  /** Responsive sizes attribute applied to both the WebP source and the fallback img. */
  sizes?: string;
  alt: string;
}

/**
 * Renders a <picture> that serves WebP to modern browsers and a JPEG/PNG
 * fallback to older ones, with optional responsive srcset/sizes so smaller
 * screens download smaller files.
 */
export function Picture({
  webpSrcSet,
  fallbackSrcSet,
  fallbackSrc,
  sizes,
  alt,
  ...imgProps
}: PictureProps) {
  return (
    <picture>
      <source type="image/webp" srcSet={webpSrcSet} sizes={sizes} />
      <img
        src={fallbackSrc}
        srcSet={fallbackSrcSet}
        sizes={sizes}
        alt={alt}
        {...imgProps}
      />
    </picture>
  );
}
